import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Crown, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PremiumGate = ({ children, feature = "This feature" }) => {
  const { user } = useAuth();
  if (user?.is_premium) return children;
  return (
    <div data-testid="premium-gate" className="rounded-2xl bg-gradient-to-br from-secondary/10 to-accent/10 border-2 border-dashed border-secondary/40 p-10 text-center">
      <div className="h-14 w-14 rounded-2xl bg-secondary/15 flex items-center justify-center mx-auto mb-4"><Lock className="h-7 w-7 text-secondary" /></div>
      <h3 className="font-head text-2xl font-bold tracking-tight">{feature} is Premium</h3>
      <p className="text-muted-foreground mt-2 max-w-md mx-auto">Upgrade to My Pack Premium to unlock AI research, pack/behaviour analysis, custom training plans and professional course access.</p>
      <Link to="/upgrade"><Button data-testid="gate-upgrade-btn" className="rounded-full mt-5 bg-secondary hover:bg-secondary/90"><Crown className="h-4 w-4 mr-1" /> Go Premium — $2.99/mo</Button></Link>
    </div>
  );
};
